import { Rule } from "antd/es/form";
import { ColProps } from "antd/es/grid/col";

type ValidationType = {
  oldPassword: {
    rules: Rule[];
    wrapperCol: ColProps;
    labelCol: ColProps;
  };
  password: {
    rules: Rule[];
    tooltip: string;
    wrapperCol: ColProps;
    labelCol: ColProps;
  };
  confirmPassword: {
    rules: Rule[];
    wrapperCol: ColProps;
    labelCol: ColProps;
  };
};

export const inputs: ValidationType = {
  oldPassword: {
    wrapperCol: {
      span: 24,
    },
    labelCol: {
      span: 24,
    },
    rules: [
      {
        required: true,
        message: "Ju lutemi vendosni fjalëkalimin!",
      },
    ],
  },
  password: {
    tooltip:
      "Fjalëkalimi duhet të ketë të paktën 8 karaktere, një shkronjë të madhe, një numër dhe një simbol!",
    wrapperCol: {
      span: 24,
    },
    labelCol: {
      span: 24,
    },
    rules: [
      {
        // required: true,
        // message: 'Ju lutemi vendosni fjalekalimin!',
      },
      {
        validator: (_, value) => {
          if (
            value &&
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^\w\s]).{8,}$/.test(value)
          ) {
            return Promise.resolve();
          }
          return Promise.reject(
            "Fjalëkalimi duhet të ketë të paktën 8 karaktere, një shkronjë të madhe, një numër dhe një simbol!",
          );
        },
      },
    ],
  },
  confirmPassword: {
    wrapperCol: {
      span: 24,
    },
    labelCol: {
      span: 24,
    },
    rules: [
      {
        required: true,
        message: "Ju lutemi konfirmoni fjalëkalimin tuaj!",
      },
      ({ getFieldValue }) => ({
        validator(_, value) {
          if (!value || getFieldValue("password") === value) {
            return Promise.resolve();
          }
          return Promise.reject(
            new Error("Ju lutemi vendosni fjalëkalimin e njejtë!"),
          );
        },
      }),
    ],
  },
};
